import React, { useState } from "react";
import api from "../api/api";
import { Upload, Download } from "lucide-react";

const ResumeUpload = ({ interviewId }) => {
  const [file, setFile] = useState(null);
  const [uploading, setUploading] = useState(false);

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      alert("Please select a file first");
      return;
    }
    try {
      setUploading(true);
      const formData = new FormData();
      formData.append("resume", file);

      await api.post(`/resume/${interviewId}/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      alert("✅ Resume uploaded successfully!");
      setFile(null);
    } catch (err) {
      console.error("Upload failed", err);
      alert("❌ Failed to upload resume");
    } finally {
      setUploading(false);
    }
  };

  const handleDownload = async () => {
    try {
      const res = await api.get(`/resume/${interviewId}/download`, {
        responseType: "blob",
      });

      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `resume_${interviewId}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (err) {
      console.error("Download failed", err);
      alert("❌ Failed to download resume");
    }
  };

  return (
    <div className="mt-3 bg-gray-50 border border-gray-200 rounded-lg p-4 shadow-sm">
      <h4 className="text-sm font-semibold text-gray-700 mb-2">
        📄 Resume Management
      </h4>
      <div className="flex flex-col sm:flex-row items-start sm:items-center gap-3">
        <input
          type="file"
          onChange={handleFileChange}
          className="block w-full text-sm text-gray-600 
                     file:mr-4 file:py-1 file:px-3
                     file:rounded-md file:border-0
                     file:text-sm file:font-semibold
                     file:bg-blue-50 file:text-blue-600
                     hover:file:bg-blue-100"
        />
        <div className="flex gap-2">
          <button
            onClick={handleUpload}
            disabled={uploading}
            className="flex items-center gap-1 px-3 py-1 bg-blue-500 hover:bg-blue-600 
                       text-white text-sm rounded-md shadow-sm transition disabled:opacity-50"
          >
            <Upload className="w-4 h-4" />
            {uploading ? "Uploading..." : "Upload"}
          </button>
          <button
            onClick={handleDownload}
            className="flex items-center gap-1 px-3 py-1 bg-green-500 hover:bg-green-600 
                       text-white text-sm rounded-md shadow-sm transition"
          >
            <Download className="w-4 h-4" />
            Download
          </button>
        </div>
      </div>
    </div>
  );
};

export default ResumeUpload;
